import Vue from 'vue'
import URLS from '../../../api/endpoints'

export default {
  getAll () {
    return Vue.http.get(URLS.GET_ALL_LOCATIONS, { params: {
      entity: 'locations'
    }})
  }
}



// WEBPACK FOOTER //
// ./src/modules/location/store/service.js